<template>
  <van-button
    plain
    @click="click"
    :style="{'backgroundColor': isChecked ? '#1090ff' : 'transparent', color: isChecked ? 'white' : '#333'}"
    style="height: 28px; line-height: 28px; color: #333" round>
    {{text}}
  </van-button>
</template>

<script>

  import Emitter from 'element-ui/src/mixins/emitter'
  import { Button } from 'vant'

  export default {
    name: 'CheckButton',
    mixins: [Emitter],
    components: {
      [Button.name]: Button
    },
    props: {
      text: {
        type: String,
        required: true
      },
      label: {
        type: [String, Number],
        default: null
      },
      judge: String
    },
    methods: {
      click () {
        if (this.label != null && this.checkButtonGroup) {
            if (this.judge === 'radio') {
                if (this.checkButtonGroup.value.length > 0 && this.checkButtonGroup.value[0] !== this.label) {
                  this.checkButtonGroup.value.splice(0, 1)
              }
            }
          const value = this.checkButtonGroup.value
          if (this.isChecked) {
            const index = value.indexOf(this.label)
            if (index > -1) {
              value.splice(index, 1)
            }
          } else {
            value.push(this.label)
          }
          this.checkButtonGroup.$emit('input', value)
          // this.dispatch('CheckButtonGroup', 'input', [123]) 另一种方式，来自 el-checkbox
        }
      }
    },
    computed: {
      checkButtonGroup () {
        let parent = this.$parent
        while (parent) {
          if (parent.$options.componentName === 'CheckButtonGroup') {
            return parent
          }
          parent = parent.$parent
        }
        return null
      },
      isChecked () {
        return this.checkButtonGroup.value.indexOf(this.label) > -1
      }
    }
  }
</script>

<style>
</style>
